import TimelineCircleImage from "../../../../timeline/TimelineCircleImage/TimelineCircleImage";

const Image = require('../../../../../assets/img/timeline/modal/2016-paloma.jpg');

const TrialResultsContent = () => {
    return (
        <>
            <TimelineCircleImage image={Image} />
            <h4>
                PALOMA-2 clinical trial results
            </h4>
            <p>
                The results of the PALOMA-2 clinical trial shows that palbociclib in combination with letrozole markedly improves progression-free survival rates for postmenopausal women with advanced or metastatic hormone receptor positive breast cancer. The Breast Cancer Trials Study Chair of PALOMA-2 is Dr Janine Lombard.
            </p>
        </>
    );
}

export default TrialResultsContent;